import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './CyberLiabilityInformationComponent.metadata.json5';

import styles from '../ArchitectEngineer.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function CyberLiabilityInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('CyberLiabilityInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesToAnyOfTheAbo10: {
            visible: (!_.isUndefined(modelVM.value.doeTheAppStoAnyMedHea2) && modelVM.value.doeTheAppStoAnyMedHea2) ||
            (!_.isUndefined(modelVM.value.doeTheComColRetAnySen3) && modelVM.value.doeTheComColRetAnySen3) ||
            (!_.isUndefined(modelVM.value.doeTheAppFolTheMinSta4) && modelVM.value.doeTheAppFolTheMinSta4) ||
            (!_.isUndefined(modelVM.value.doeTheComFolTheMinSta5) && modelVM.value.doeTheComFolTheMinSta5) ||
            (!_.isUndefined(modelVM.value.areYouAwaOfAnyCusEmp6) && modelVM.value.areYouAwaOfAnyCusEmp6) ||
            (!_.isUndefined(modelVM.value.hasYouOrgBeeChaOrFin7) && modelVM.value.hasYouOrgBeeChaOrFin7) ||
            (!_.isUndefined(modelVM.value.hasYouOrgComNetBeeBre8) && modelVM.value.hasYouOrgComNetBeeBre8) ||
            (!_.isUndefined(modelVM.value.hasAnyChaWitYouSysRel9) && modelVM.value.hasAnyChaWitYouSysRel9)
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

CyberLiabilityInformationComponent.propTypes = wizardProps;
export default withRouter(CyberLiabilityInformationComponent);
